import { isEqual } from 'lodash';
import MimirService from '../services/mimir-service';

import {
    FETCH_AGGREGATE_DOMAINS_REQUEST,
    FETCH_AGGREGATE_DOMAINS_SUCCESS,
    FETCH_AGGREGATE_DOMAINS_FAILURE,
} from './types/aggregate-domains-action-types';
import { prevAggDomainsParamsSelector } from '../selectors/aggregate-domains-selectors';

function fetchAggDomainsRequest( params = {} ){
    return {
        params,
        type: FETCH_AGGREGATE_DOMAINS_REQUEST,
    };
}

function fetchAggDomainsSuccess( response ){
    return {
        type: FETCH_AGGREGATE_DOMAINS_SUCCESS,
        ...response
    };
}

function fetchAggDomainsFailure( error ){
    return {
        error,
        type: FETCH_AGGREGATE_DOMAINS_FAILURE,
    };
}

function fetchAggDomains( params ){
    return ( dispatch, getState, { DATA_API } ) => {
        dispatch( fetchAggDomainsRequest( params ) );
        const api = new MimirService( DATA_API );

        return api.getAggregateDomains( params ).then(
            ( response ) => dispatch( fetchAggDomainsSuccess( response ) ),
            ( error ) => dispatch( fetchAggDomainsFailure( error ) )
        );
    };
}

export function fetchAggDomainsIfNeeded( params ){
    return ( dispatch, getState, { DATA_API } ) => {
        const state = getState();
        const prevParams = prevAggDomainsParamsSelector( state );

        if( !isEqual( params, prevParams ) ){
            return dispatch( fetchAggDomains( params ) );
        }
        else{
            return Promise.resolve();
        }
    };
}
